// Import Custom Conponents

import Scroll from './components/Scroll';
import Header from './components/Header';
import Sliders from './components/Sliders';
import Tabbed from './components/Tabbed';
import Expander from './components/Expander';
import Filters from './components/Filters';
import Availabilities from './components/Availabilities';

// Form Redirect

Scroll.init();
Header.init();
Sliders.init();
Tabbed.init();
Expander.init();
Filters.init();
Availabilities.init();

document.addEventListener(
	'wpcf7mailsent',
	function (event) {
		const formels = document.querySelectorAll(
			'.wpcf7-form > *:not(.wpcf7-response-output)'
		);
		// location = '/thank-you/';
		formels.forEach((el) => {
			el.style.display = 'none';
		});
	},
	false
);
